import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'position_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    source: String // home 首页 category 分类页 children 子页面 template 模版库
  },
  created: function created() {
    var _this$value$config = this.value.config,
      _this$value$config$po = _this$value$config.position_show,
      position_show = _this$value$config$po === void 0 ? true : _this$value$config$po,
      _this$value$config$ic = _this$value$config.icon_font_size,
      icon_font_size = _this$value$config$ic === void 0 ? 40 : _this$value$config$ic,
      _this$value$config$ic2 = _this$value$config.icon_color,
      icon_color = _this$value$config$ic2 === void 0 ? '#c20c0c' : _this$value$config$ic2,
      _this$value$config$fo = _this$value$config.font_size,
      font_size = _this$value$config$fo === void 0 ? 28 : _this$value$config$fo,
      _this$value$config$co = _this$value$config.color,
      color = _this$value$config$co === void 0 ? '#c20c0c' : _this$value$config$co,
      _this$value$config$en = _this$value$config.enter_icon_font_size,
      enter_icon_font_size = _this$value$config$en === void 0 ? 20 : _this$value$config$en,
      _this$value$config$en2 = _this$value$config.enter_icon_color,
      enter_icon_color = _this$value$config$en2 === void 0 ? '#c20c0c' : _this$value$config$en2,
      _this$value$config$ba = _this$value$config.back_button_show,
      back_button_show = _this$value$config$ba === void 0 ? false : _this$value$config$ba,
      _this$value$config$ba2 = _this$value$config.back_size,
      back_size = _this$value$config$ba2 === void 0 ? 20 : _this$value$config$ba2,
      _this$value$config$ba3 = _this$value$config.back_color,
      back_color = _this$value$config$ba3 === void 0 ? '#111111' : _this$value$config$ba3;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      position_show: position_show,
      icon_font_size: icon_font_size,
      icon_color: icon_color,
      font_size: font_size,
      color: color,
      enter_icon_font_size: enter_icon_font_size,
      enter_icon_color: enter_icon_color,
      back_button_show: back_button_show,
      back_size: back_size,
      back_color: back_color
    }));
  }
};